/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationAppIcon32Regular = forwardRef('NotificationAppIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.5 1a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM20 7.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0Z" }),
        React.createElement("path", { d: "M5 8.5A3.5 3.5 0 0 1 8.5 5H15a1 1 0 1 0 0-2H8.5A5.5 5.5 0 0 0 3 8.5v15A5.5 5.5 0 0 0 8.5 29h15a5.5 5.5 0 0 0 5.5-5.5V17a1 1 0 1 0-2 0v6.5a3.5 3.5 0 0 1-3.5 3.5h-15A3.5 3.5 0 0 1 5 23.5v-15Z" })));
});
